'use client'

import { configureLogger } from 'tokyu-hooks'
import { clientLogger } from 'lib/logger/client'

// Configure once at client startup — runs when AppContext module is first imported
configureLogger(clientLogger)

import { useState } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { SessionProvider } from 'next-auth/react'

import { getQueryClient_CLIENT_SIDE } from 'app/getQueryClient'
import WindowUserSync from 'app/components/atoms/WindowUserSync'

import BaseUrlContextProvider from '../BaseUrlContext'
import PersonalInfoContextProvider from '../PersonalInfoContext'
import CompleteReservationContextProvider from '../CompleteReservationContext'

export const AppContext: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const [queryClient] = useState(() => getQueryClient_CLIENT_SIDE())

  return (
    <SessionProvider>
      <WindowUserSync />
      <QueryClientProvider client={queryClient}>
        <PersonalInfoContextProvider>
          <BaseUrlContextProvider>
            <CompleteReservationContextProvider>
              {children}
            </CompleteReservationContextProvider>
          </BaseUrlContextProvider>
        </PersonalInfoContextProvider>
      </QueryClientProvider>
    </SessionProvider>
  )
}
